<ngx-skeleton-loader
  *ngIf="loaderService.isLoading"
  [count]="count"
  [theme]="themeOptions"
>
</ngx-skeleton-loader>
